/** 記事CMSのURLパス先頭（先頭スラッシュなし）。Netlify の VITE_ADMIN_PATH とローカル .env で上書き可 */
export const ADMIN_PAGE_PATH =
  (import.meta.env.VITE_ADMIN_PATH as string | undefined)?.replace(/^\/+/, '').trim() ||
  'st-cms-7f3a9b2e1c4d8e06';
